import { render, staticRenderFns } from "./sidebar.vue?vue&type=template&id=37c6bc06&"
var script = {}
import style0 from "./sidebar.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports